import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService} from '../data.service';
import { FormControl, NgForm, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import { Preinscripcio } from '../lib/model/preinscripcio';
import { Universitat } from '../lib/model/universitat';
import { Pais } from '../lib/model/pais';
import { IValue } from '../lib/model/ivalue';
import { Estudi } from '../lib/model/estudi';
import { Utilitats } from '../lib/utilitats';
import { HttpClient } from '@angular/common/http';
import { BLEstudi } from '../lib/bl/blestudi';
import { BLPreinscripcio } from '../lib/bl/blpreinscripcio';
import { DocumentPreinscripcio } from '../lib/model/documentPreinscripcio';
import { MatStepper, MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-estudis',
  templateUrl: './estudis.component.html',
  styleUrls: ['./estudis.component.css'],
  providers: [BLEstudi, BLPreinscripcio]
})
export class EstudisComponent implements OnInit {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;
  notaMitjanaInput = new FormControl('', [Validators.max(10), Validators.min(0)]);

  inicialitzat = false;
  dataService: DataService;
  preinscripcio: Preinscripcio;
  stepPerformed = false;

  paisCtrl: FormControl;
  universitatCtrl: FormControl;
  estudisCtrl: FormControl;

  filteredPaisos: Observable<Pais[]>;
  filteredUniversitats: Observable<Universitat[]>;
  filteredEstudis: Observable<Estudi[]>;

  estudis: Estudi[] = new Array<Estudi>();

  constructor(  dataService: DataService,
                private http: HttpClient,
                public utilitats: Utilitats,
                private blestudi: BLEstudi,
                private blPreinscripcio: BLPreinscripcio,
                public snackBar: MatSnackBar) {

    this.dataService = dataService;
    this.preinscripcio = this.dataService.preinscripcio;

    this.paisCtrl = new FormControl();
    this.filteredPaisos = this.paisCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraPaisos(x) : this.dataService.paisos);

    this.universitatCtrl = new FormControl();
    this.filteredUniversitats = this.universitatCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.dataService.filtraUniversitats(x) : this.dataService.universitats);

    this.estudisCtrl = new FormControl();
    this.setFilteredEstudis();
  }

  async ngOnInit() {
    await this.loadEstudis();
    this.inicialitzat = true;
  }

  filtraEstudis(x): Estudi[] {
    const z = this;
    return this.estudis.filter(function(y) {
      const x1 = z.dataService.normalize(z.utilitats.getString(x).toLowerCase());
      const y1 = z.dataService.normalize(y.name.toLowerCase());
      return y1.includes(x1);
    });
  }

  setFilteredEstudis() {
    this.filteredEstudis = this.estudisCtrl.valueChanges
        .startWith(null)
        .map(x => x ? this.filtraEstudis(x) : this.estudis);
  }

  async loadEstudis() {
    this.estudis = new Array<Estudi>();
    const estudiRealitzat = this.preinscripcio.estudiRealitzat;
    if (this.inicialitzat) {
      estudiRealitzat.estudi = null;
    }
    this.estudis = await this.blestudi.list(
      estudiRealitzat.pais,
      estudiRealitzat.universitat,
      this.preinscripcio.alumne,
      this.dataService.current_language);
    this.setFilteredEstudis();
  }

  async loadDocuments() {
    const documents = await this.blPreinscripcio.getDocuments(this.preinscripcio);
    this.preinscripcio.documents = new Array<DocumentPreinscripcio>();
    Object.assign(this.preinscripcio.documents, documents);
  }

  async paisChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.preinscripcio.estudiRealitzat;
        if ((estudiRealitzat.pais === null) ||
            (estudiRealitzat.pais.value !== newValue.value)) {
          estudiRealitzat.pais = newValue;
          await this.loadEstudis();
          await this.loadDocuments();
        }
      } else {
        this.preinscripcio.estudiRealitzat.pais = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  async universitatChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.preinscripcio.estudiRealitzat;
        if ((estudiRealitzat.universitat === null) ||
            (estudiRealitzat.universitat.value !== newValue.value)) {
          this.preinscripcio.estudiRealitzat.universitat = newValue;
          await this.loadEstudis();
          await this.loadDocuments();
        }
      } else {
        this.preinscripcio.estudiRealitzat.universitat = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  estudiChange(newValue) {
    try {
      if (newValue != null && newValue.value) {
        const estudiRealitzat = this.preinscripcio.estudiRealitzat;
        if ((estudiRealitzat.estudi === null) ||
            (estudiRealitzat.estudi.value !== newValue.value)) {
          this.preinscripcio.estudiRealitzat.estudi = newValue;
        }
      } else {
          this.preinscripcio.estudiRealitzat.estudi = null;
      }
    } catch (err) {
      console.log(err);
    }
  }

  nombreColumnes(): number {
    if (this.preinscripcio.estudiRealitzat.universitatGirona()) {
      return 3;
    }
    return 4;
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
      // TODO: Tenim una barreja de dos estils, template driven i reactive driven, per això cal validar algunes coses a banda
      if (this.notaMitjanaInput.invalid) {
        return false;
      }
      const estudiRealitzat = this.preinscripcio.estudiRealitzat;
      if (estudiRealitzat.pais == null) {
          return false;
      }
      if (estudiRealitzat.universitat == null && this.utilitats.isNullOrEmpty(estudiRealitzat.universitatText)) {
          return false;
      }
      if (estudiRealitzat.estudi == null && this.utilitats.isNullOrEmpty(estudiRealitzat.estudiText)) {
          return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }

  public async continua() {
    try {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
      if (!this.preinscripcio.isnew) {
        this.preinscripcio = await this.blPreinscripcio.save(this.preinscripcio);
        this.dataService.preinscripcio = this.preinscripcio;
      }
    } catch (ex) {
        console.log(ex.Message);
        this.snackBar.open(ex.Message, null, {
            duration: 10000,
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/estudis/estudis.component.ts